export default __webpack_public_path__ + "static/media/Imac.eb1f490b.png";